import WinDoPassConfigType from "../../model/odata/enum/WinDoPassConfigType";
import Util from "ips/ac/util/Util";

export default function(winDoPassConfigType: WinDoPassConfigType) {
  let key: string;

  switch (winDoPassConfigType) {
    // COVER_FRAME
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldDesignText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_HEIGHT_ENABLED:
      key = "@ClientWindowPassShowFieldHeight";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ENABLED:
      key = "@ClientWindowPassShowFieldType";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_WIDTH_ENABLED:
      key = "@ClientWindowPassShowFieldWidth";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_TYPE_ALU_ENABLED:
      key = "@ClientWindowPassShowFieldTypeAlu";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_COVER_FRAME_DESIGN_TEXT_ALU_ENABLED:
      key = "@ClientWindowPassShowFieldDesignTextAlu";
      break;

    // CASEMENT
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldDesignText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_HEIGHT_ENABLED:
      key = "@ClientWindowPassShowFieldHeight";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ENABLED:
      key = "@ClientWindowPassShowFieldType";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_WIDTH_ENABLED:
      key = "@ClientWindowPassShowFieldWidth";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_TYPE_ALU_ENABLED:
      key = "@ClientWindowPassShowFieldTypeAlu";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_CASEMENT_DESIGN_TEXT_ALU_ENABLED:
      key = "@ClientWindowPassShowFieldDesignTextAlu";
      break;

    // Fitting
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ARTICLE_TYPE_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldArticleTypeText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_FITTING_ORDER_NUMBER_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldOrderNumberText";
      break;

    // GLASS
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DEPTH_ENABLED:
      key = "@ClientWindowPassShowFieldDepth";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_DESCRIPTION_ENABLED:
      key = "@ClientWindowPassShowFieldDescription";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_HEIGHT_ENABLED:
      key = "@ClientWindowPassShowFieldHeight";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_LONG_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldLongText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SALES_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldSalesText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SHORT_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldShortText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_01_ENABLED:
      key = "@ClientWindowPassShowFieldSpecialGlass01";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_SPECIAL_GLASS_02_ENABLED:
      key = "@ClientWindowPassShowFieldSpecialGlass02";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_TECHNICAL_DATA_GLASS_WIDTH_ENABLED:
      key = "@ClientWindowPassShowFieldWidth";
      break;

    // ACCESSORY
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_CUSTOMER_TEXT_ENABLED:
      key = "@ClientWindowPassShowFieldCustomerText";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_HEIGHT_ENABLED:
      key = "@ClientWindowPassShowFieldHeight";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_NET_PRICE_ENABLED:
      key = "@ClientWindowPassShowFieldPrice";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_NOTE_ENABLED:
      key = "@ClientWindowPassShowFieldNote";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_QUANTITY_ENABLED:
      key = "@ClientWindowPassShowFieldQuantity";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_TEXT_LONG_ENABLED:
      key = "@ClientWindowPassShowFieldTextLong";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_TEXT_SHORT_ENABLED:
      key = "@ClientWindowPassShowFieldTextShort";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_TITLE_ENABLED:
      key = "@ClientWindowPassShowFieldTitle";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_WEIGHT_ENABLED:
      key = "@ClientWindowPassShowFieldWeight";
      break;
    case WinDoPassConfigType.PRODUCT_DETAILS_ACCESSORY_WIDTH_ENABLED:
      key = "@ClientWindowPassShowFieldWidth";
      break;
    default :
      key = "WinDoPassConfig_" + winDoPassConfigType;
  }

  return Util.getText(key);
}